import { apiRequest } from './apiClient';

export async function getDisciplineSystem() {
  const response = await apiRequest('/student/discipline-system');

  return response.data || null;
}
